import { CLIENT_ROLE_LEVELS } from '@/utils/constants';

// A RoleSet is the explicit list of client role levels granted a permission.
export type RoleSet = readonly number[];

// Hierarchical: every client role at or above `level` (i.e. roleLevel <= level).
// atLeast(LED) -> [ENT, MGR, LED]
export const atLeast = (level: number): RoleSet =>
	CLIENT_ROLE_LEVELS.filter((roleLevel) => roleLevel <= level);

// Explicit set of one or more roles (covers single-role and non-hierarchical subsets).
// allOf(MGR, LED) -> [MGR, LED].
export const allOf = (...levels: number[]): RoleSet => levels;

// Semantic aliases. Frozen because NONE is shared across multiple rules.
export const ALL: RoleSet = Object.freeze([...CLIENT_ROLE_LEVELS]); // ungated for all roles
export const NONE: RoleSet = Object.freeze([]); // blocked for all client roles (e.g. POS-managed)
